import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '../global.service';
import { ConfigService } from '../config.service';
import { LocalStorageService } from '../storage.service';
import { BusinessContextService } from '../business-context.service';

import { Channel, CreateChannelPayload } from './channel.interface';

@Injectable({
  providedIn: 'root'
})
export class ChannelService extends ApiService {
  constructor(
    public override http: HttpClient,
    public override config: ConfigService,
    public override localStorageService: LocalStorageService,
    handler: HttpBackend,
    private bizCtx: BusinessContextService,
  ) {
    super(http, config, localStorageService, handler);
  }

  private getBusiness(): string {
    return this.bizCtx.getSelected() || this.getActiveBusiness();
  }

  listChannels(): Observable<Channel[]> {
    const business = this.getBusiness();
    return this.get<Channel[]>(`${this.URL}/channel/${business}`);
  }

  createChannel(payload: CreateChannelPayload): Observable<Channel> {
    const business = this.getBusiness();
    return this.create<Channel>(`${this.URL}/channel/${business}`, payload);
  }

  updateChannel(channelUuid: string, payload: Partial<CreateChannelPayload>): Observable<Channel> {
    const business = this.getBusiness();
    return this.patch<Channel>(`${this.URL}/channel/${business}/${channelUuid}`, payload);
  }

  deleteChannel(channelUuid: string): Observable<any> {
    const business = this.getBusiness();
    return this.delete<any>(`${this.URL}/channel/${business}/${channelUuid}`);
  }

  linkTablesToChannel(channelUuid: string, tableUuids: string[]): Observable<any> {
    const business = this.getBusiness();
    return this.create<any>(`${this.URL}/channel/${business}/${channelUuid}/tables`, { tableUuids });
  }

  unlinkTableFromChannel(channelUuid: string, tableUuid: string): Observable<any> {
    const business = this.getBusiness();
    return this.delete<any>(`${this.URL}/channel/${business}/${channelUuid}/tables/${tableUuid}`);
  }

  linkTableTypesToChannel(channelUuid: string, tableTypes: string[]): Observable<any> {
    const business = this.getBusiness();
    return this.create<any>(`${this.URL}/channel/${business}/${channelUuid}/table-types`, { tableTypes });
  }

  unlinkTableTypeFromChannel(channelUuid: string, tableType: string): Observable<any> {
    const business = this.getBusiness();
    return this.delete<any>(`${this.URL}/channel/${business}/${channelUuid}/table-types/${tableType}`);
  }

  linkMenuProductsToChannel(channelUuid: string, menuProductUuids: string[]): Observable<any> {
    const business = this.getBusiness();
    return this.create<any>(`${this.URL}/channel/${business}/${channelUuid}/menu-products`, { menuProductUuids });
  }

  unlinkMenuProductFromChannel(channelUuid: string, menuProductUuid: string): Observable<any> {
    const business = this.getBusiness();
    return this.delete<any>(`${this.URL}/channel/${business}/${channelUuid}/menu-products/${menuProductUuid}`);
  }
}
